export const positionEndIdx = (value) => {
  if (!value) return;
  let idx;
  idx = value?.indexOf("l4");
  if (idx > -1) return idx + 2;
  idx = value?.indexOf("l3");
  if (idx > -1) return idx + 2;
  idx = value?.indexOf("l2");
  if (idx > -1) return idx + 2;
  idx = value?.indexOf("l1");
  if (idx > -1) return idx + 2;
  return 0;
};

export const extractPosition = (value) => {
  return value?.slice(0, positionEndIdx(value));
};

export const extractTreeIndex = (value) => {
  const position = extractPosition(value);
  const replacedPosition = position
    .replaceAll("l1", "tempValue")
    .replaceAll("l2", "tempValue")
    .replaceAll("l3", "tempValue")
    .replaceAll("l4", "tempValue")
    .replaceAll("l5", "tempValue");
  return replacedPosition
    .split("tempValue")
    .filter((i) => i !== "")
    .map((i) => Number(i));
};

export const extractTreeWords = (value, data, section, subSection1) => {
  if (!value || !data || !section) return [];
  let treeWords = [];
  try {
    const subSection2 = section !== "surah" ? "subjects" : "verses";
    const subTitle = section !== "surah" ? "title" : "verse_no";
    const treeIndex = extractTreeIndex(value);
    const [lvl1, lvl2, lvl3, lvl4, lvl5] = treeIndex;

    if (lvl1 >= 0) treeWords.push(data[lvl1][subSection1]);
    if (lvl2 >= 0) treeWords.push(data[lvl1][subSection2][lvl2][subTitle]);
    if (lvl4 >= 0)
      treeWords.push(
        data[lvl1][subSection2][lvl2].sub_subjects[lvl3].subjects_3[lvl4]
          .originalTitle
      );
    if (lvl3 >= 0)
      treeWords.push(data[lvl1][subSection2][lvl2].sub_subjects[lvl3].title);
  } catch {}
  return treeWords;
};
export const extractText = (value) => {
  return value?.slice(positionEndIdx(value));
};

export const makeTreeOptions = (treeWords, section) => {
  const treeOption = {};
  const treeKeyNarration = [
    "alphabet",
    "subject",
    "sub_subject",
    "subject_3",
    "subject_4",
  ];
  const treeKeySurah = [
    "surah_name",
    "verse_no",
    "sub_subject",
    "subject_3",
    "subject_4",
  ];
  const treeKey = section !== "surah" ? treeKeyNarration : treeKeySurah;
  treeWords.forEach((word, index) => {
    if (word) treeOption[treeKey[index]] = word;
  });
  return treeOption;
};

export const getSortType = (headerDataKey, sortColumn, isSortAscending) => {
  if (headerDataKey !== sortColumn) return "Sorting";
  if (isSortAscending) return "SortingAscending";
  return "SortingDescending";
};

const alterChar = "-";
const isTitleCombined = (text) => replaceText(text)?.includes(alterChar);

const replaceText = (text) =>
  text
    ?.replace("-", alterChar)
    ?.replace("_", alterChar)
    ?.replace("ـ", alterChar)
    ?.replace("–", alterChar);

const getNewLevel3And4Titles = (oldLevel3Title) => {
  let level3Title, level4Title;

  if (!isTitleCombined(oldLevel3Title)) {
    level3Title = oldLevel3Title;
  } else {
    const oldLevel3TitleSplit = oldLevel3Title?.split(alterChar);
    level3Title = oldLevel3TitleSplit?.[0]?.trim();
    level4Title = oldLevel3TitleSplit?.[1]?.trim();
  }

  return { level3Title, level4Title };
};

export const get4LevelsData = (data) => {
  const data4Levels = data?.map((lvl1) => {
    return {
      ...lvl1,
      subjects: lvl1?.subjects?.map((lvl2) => {
        const lvl3Object = {};
        lvl2?.sub_subjects?.forEach((lvl3) => {
          const lvl3Title = lvl3?.title;
          const lvl3TitleCleaned = replaceText(lvl3Title);
          const currentKeys = Object.keys(lvl3Object);

          const { level3Title, level4Title } =
            getNewLevel3And4Titles(lvl3TitleCleaned);
          const doesLevel3Exist = currentKeys?.includes(level3Title);

          const level4Data = {
            originalTitle: lvl3Title,
            level4Title: level4Title,
          };

          if (!doesLevel3Exist) {
            lvl3Object[level3Title] = !!level4Title ? [level4Data] : [];
          } else if (doesLevel3Exist && !!level4Title) {
            lvl3Object[level3Title]?.push(level4Data);
          }
        });

        return {
          ...lvl2,
          sub_subjects: Object.entries(lvl3Object)?.map(
            ([newLevel3Title, value]) => {
              const level4Titles = value?.map((data) => ({
                title: data.level4Title,
                originalTitle: data.originalTitle,
              }));
              return {
                title: newLevel3Title,
                subjects_3: level4Titles,
              };
            }
          ),
        };
      }),
    };
  });
  return data4Levels;
};
